import Common from "../../Common";

const Users = class extends Common {
	async browse(id: id) {
		return this.get(`/queue/${id}/member`);
	}

	// async update(
	// 	queueId: any,
	// 	queueMemberId: any,
	// 	data: {
	// 		paused: string
	// 	}
	// ) {
	// 	return this.patch(`/queue/${queueId}/member/${queueMemberId}`, data)
	// }

	// async delete(queueId: any, queueMemberId: any)
	// {
	// 	return this.delete(`/queue/${queueId}/member/${queueMemberId}`)
	// }

	// queue/{queueId}/member/{queueMemberId}
}

export default Users
